<template>
	<div class="mainLeft">
		<item @support="fn" :obj="obj" v-if="show" />
		<div v-else id="notFind">暂无数据</div>
		<comment v-if="show" />
		<toast ref="toast" :content="content" />
	</div>
</template>

<script>
	import item from '@/components/common/item'
	import comment from '@/components/common/comment'
	import toast from '@/components/common/toast'

	import axios from '@/axios/'

	export default {
		components: {
			item,
			comment,
			toast
		},
		async created() {
			window.scrollTo(0, 0);
			let type = this.$route.query.type;
			let id = this.$route.query.id;
			if (type && id) {
				try {
					let {data} = await axios('/detail', {
						params: {
							type,
							id,
						}
					});
					if (data.code == 200 && data.data) {
						this.obj = data.data;
						this.show = true;
					} else {
						this.show = false;
					}
				} catch (e) {
					//
				}
			} else {
				this.$router.push({path: '/'});
			}
		},
		data() {
			return {
				obj: {}, //
				show: true,
				content:'',
			}
		},
		methods: {
			async fn(obj) {
				let {data} = await axios('/detail/supports',{
					params: {
						type:obj.type,
						id:obj.id
					}
				});
				if (data.code == 200) {
					this.obj.support++;	//给子级更新数据
					this.content = data.msg;	//给用户友好提示
					this.$refs.toast.flag = true;
				}
			}
		},
	}
</script>

<style scoped>
	.mainLeft {
		width: 950px;
		float: left;
	}

	#notFind {
		text-align: center;
		color: #999;
		width: 100%;
		background-color: #fff;
		padding: 20px;
		box-sizing: border-box;
	}
</style>
